import { Typography } from '@bowtie-ins/bowkit';
import { GRAPHITE } from '@bowtie-ins/bowkit/palette';
import { Product } from '@bowtie-web/common';
import { Box } from '@material-ui/core';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { QuotationContextValue } from '../contexts/QuotationContext';
import ProductCard from './ProductCard/ProductCard';

type Props = Pick<
  QuotationContextValue,
  'activeProduct' | 'coupon' | 'products' | 'bulkQuotation'
> & {
  onActiveProductChange: QuotationContextValue['setActiveProduct'];
  formValues: QuotationContextValue['values'];
  size: 'small' | 'large';
  isValid: boolean;
  productToBadgeMapping?: { productCode: string; badge: React.ReactNode };
};

const ResultPanel = ({
  activeProduct,
  onActiveProductChange,
  products,
  isValid,
  size,
  bulkQuotation,
  productToBadgeMapping,
}: Props) => {
  const handleClick = useCallback(
    (newActiveProduct: Product) => {
      onActiveProductChange(newActiveProduct);
    },
    [onActiveProductChange],
  );

  return (
    <Box display="flex" flexDirection="column" gridGap={8}>
      <Box
        display="flex"
        flexDirection={size === 'small' ? 'column' : 'row'}
        gridGap={16}
      >
        {products.map((product, ix) => {
          const quotation = bulkQuotation.find(
            quotation => quotation.product.code === product.code,
          )?.quotation;

          return (
            <ProductCard
              key={ix}
              product={product}
              selected={product.code === activeProduct?.code}
              onClick={handleClick}
              isValid={isValid}
              size={size}
              quotation={quotation}
              badge={
                productToBadgeMapping?.productCode &&
                product.code.includes(productToBadgeMapping.productCode)
                  ? productToBadgeMapping.badge
                  : undefined
              }
            />
          );
        })}
      </Box>
      {productToBadgeMapping?.productCode
        .toLowerCase()
        .includes('term-level-life') && productToBadgeMapping.badge ? (
        <Typography variant="body-s" style={{ color: GRAPHITE }}>
          <FormattedMessage id="level-term-life-price-difference.remarks" />
        </Typography>
      ) : null}
    </Box>
  );
};

export default ResultPanel;
